import { render, staticRenderFns } from "./AdvanceRegistrationConfig.vue?vue&type=template&id=30d1d1bc"
import script from "./AdvanceRegistrationConfig.vue?vue&type=script&lang=ts"
export * from "./AdvanceRegistrationConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports